// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Scormengine = createSvgIcon(
  { LeftToRight: <React.Fragment><g stroke="currentColor" strokeWidth="2"><path d="M2.1158 9.488c-.9018 1.1925-1.363 2.3436-.9483 2.9358.7984 1.1402 3.3838.2912 6.7102-2.038 3.3264-2.3292 6.752-5.5011 6.0017-7.0012-.4999-.9995-2.2453-.7965-3.5006.5005" /><path d="M12.9304 6.7275c1.4702.6727 2.1699 1.549 2.0695 2.2725-.1933 1.3929-1.6341 1.586-7.812 1.086C2.8095 9.4785.5457 7.693 1.1271 6.1689c.5816-1.524 2.556-1.5589 4.0945-1.8122" /><circle cx="8.0146" cy="8.5391" r="5" /></g><defs></defs></React.Fragment>, },
  'small'
);
